<template>
    <page>
        <module>
            <view-list ref="view" :work-type="workType" :view-config="saasInfo.viewmanage" @change="getBusinessType">
                <template #search>
                    <m-search ref="search">
                        <m-search-item label="流水单号">
                            <c-input name="flow_no"></c-input>
                        </m-search-item>
                        <m-search-item v-if="businessType === 1" label="客户">
                            <c-select name="target_id" async  @search="searchTarget('SALE_CUSTOMER',arguments[0], arguments[1])"></c-select>
                        </m-search-item>
                        <m-search-item v-if="businessType === 2" label="供应商">
                            <c-select name="target_id" async  @search="searchTarget('SUPPLIER',arguments[0], arguments[1])"></c-select>
                        </m-search-item>
                        <m-search-item label="操作类型">
                            <c-select name="operate_type" :options="operateTypeOptions"></c-select>
                        </m-search-item>
                        <m-search-item label="创建时间">
                            <c-datetime range name="start_date" end-name="end_date"></c-datetime>
                        </m-search-item>
                    </m-search>
                </template>

                <template #operate>
                    <c-button v-if="businessType == 1" color="main" @click="openAddReceipt">新增预收款</c-button>
                    <c-button v-if="businessType == 2" color="main" @click="openAddPayment">新增预付款</c-button>
                    <c-button color="green" @click="openWriteOff">核销处理</c-button>
                    <c-button prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
                </template>
                <!--业务类型-->
                <template #business_type="{data}">
                    <c-state tag async dict="ADVANCE_BUSINESS_TYPE" :value="data.business_type"></c-state>
                </template>
                <!--操作类型-->
                <template #operate_type="{data}">
                    <c-state tag async dict="ADVANCE_OPERATE_TYPE" :value="data.operate_type"></c-state>
                </template>
                <!--金额（正数绿色+，负数红色-）-->
                <template #amount="{data}">
                    <span v-if="data.amount > 0" style="color: #67C23A">+ ¥{{data.amount}}</span>
                    <span v-else-if="data.amount < 0" style="color: #F56C6C">– ¥{{ Math.abs(data.amount) }}</span>
                    <span v-else>¥0</span>
                </template>
                <!--可用余额-->
                <template #balance_after="{data}">
                    <span>¥{{data.balance_after}}</span>
                </template>
                <!--客户名-->
                <template #customer_name="{data}">
                    <span>{{data.target_name}}</span>
                </template>
                <!--供应商名-->
                <template #supplier_name="{data}">
                    <span>{{data.target_name}}</span>
                </template>

            </view-list>
        </module>
    </page>
</template>

<script>
import {mapState} from 'vuex'

export default {
    name: 'm_advance_receipt_payment',

    data() {
        return {
            businessType:1,     //1=预收  2=预付
            workType: 118
        }
    },

    computed: {
        ...mapState(['saasInfo']),

        /** 操作类型选项：1=预收 2=预付 3=核销（与ADVANCE_OPERATE_TYPE字典一致），按业务方向过滤显示 */
        operateTypeOptions() {
            var options = [{
                name: '预收',
                value: 1
            }, {
                name: '预付',
                value: 2
            }, {
                name: '核销',
                value: 3
            }];
            return this.businessType === 2 ? options.filter(o => o.value !== 1) : options.filter(o => o.value !== 2);
        }
    },

    methods: {
        /*******搜索采购供应商*****************/
        searchTarget(code,keyword, resolve){
            this.request({
                url:'/system/options',
                data: {
                    options_code:code,
                    keyword:keyword
                },
                success:data => {
                    resolve(data);
                }
            })
        },
        /*******搜索业务类型*****************/
        getBusinessType(viewId) {
            //清除筛选条件
            this.$refs.view.$search.clear();
            this.request({
                url: '/advance/receipt/payment/business/type',
                data: {
                    view_id: viewId
                },
                success: data => {
                    this.businessType = data||1;
                }
            })
        },

        /** 打开新增预收款弹窗 */
        openAddReceipt() {
            this.globalDialog('advanceAddDialog', {
                props: {
                    dialogType: 'receipt'
                }
            }, () => {
                this.$refs.view.update();
            });
        },

        /** 打开新增预付款弹窗 */
        openAddPayment() {
            this.globalDialog('advanceAddDialog', {
                props: {
                    dialogType: 'payment'
                }
            }, () => {
                this.$refs.view.update();
            });
        },

        /** 打开核销处理弹窗 */
        openWriteOff() {
            this.globalDialog('advanceWriteOffDialog', {
                props: {
                    businessType: this.businessType
                }
            }, () => {
                this.$refs.view.update();
            });
        }
    }
}
</script>

<style lang="stylus" scoped>
.advance-tabs {
    display: flex;
    padding: 0 15px;
    background: #fff;
    border-bottom: 1px solid #eee;

    .tab-item {
        display: inline-block;
        padding: 12px 24px;
        font-size: 15px;
        color: #666;
        cursor: pointer;
        border-bottom: 2px solid transparent;
        transition: all .2s;

        &:hover {
            color: var(--color-main);
        }

        &.active {
            color: var(--color-main);
            border-bottom-color: var(--color-main);
            font-weight: bold;
        }
    }
}
</style>
